import { useEffect } from "react";
import useGameData from "app/game-data/useGameData";
import useGameState, {
  useGameActionDispatch,
  GameAction,
} from "app/game/useGameState";

export default function useNewGame() {
  const data = useGameData();
  const { id } = useGameState();
  const dispatch = useGameActionDispatch();

  useEffect(() => {
    if (data?.id && id !== `${data.id}`) {
      console.info(`New Game! ${data.id}`);
      dispatch({
        type: GameAction.NEW_GAME_DATA_FOUND,
        payload: { gameId: `${data.id}` },
      });
    }
  }, [dispatch, data?.id, id]);
}
